import { Tracking } from '@panamax/app-state';
import { ImportOrderValidationTracingConstants } from '../tracing/import-order-validation-tracing.constants';
import { genericTracingTransformer } from '@shared/tracking/tracing/generic-tracing-transformer';
import { ImportOrderValidationAnalyticsMessages } from '../analytics/import-order-validation-analytics.constants';
import { genericAnalyticsTransformer } from '@shared/tracking/analytics/generic-analytics-transformer';

export const createCancelImportTrace = (): Tracking => {
  return {
    tracing: {
      data: {
        traceContext: ImportOrderValidationTracingConstants.cancelContext,
        isEndOfTrace: true,
        isStartOfTrace: true,
        attributes: {
          event: ImportOrderValidationTracingConstants.event,
        },
      },
      transformFunc: genericTracingTransformer,
    },
  };
};

export const createPageLoadImportTrace = (): Tracking => {
  return {
    tracing: {
      data: {
        traceContext: ImportOrderValidationTracingConstants.pageLoadContext,
        isEndOfTrace: true,
        isStartOfTrace: true,
        attributes: {
          event: ImportOrderValidationTracingConstants.pageLoadEvent,
          order: {
            importedOrdersCount: 0,
          },
        },
      },
      transformFunc: genericTracingTransformer,
    },
  };
};

export const createPageLoadAnalytics = (): Tracking => {
  return {
    analytics: {
      data: {
        capability: ImportOrderValidationAnalyticsMessages.capability,
        event: ImportOrderValidationAnalyticsMessages.pageLoadEvent,
        page: {
          pageName: ImportOrderValidationAnalyticsMessages.pageName,
        },
      },
      transformFunc: genericAnalyticsTransformer,
    },
  };
};

export const createSubmitFileAnalytics = (typeOfFile: string): Tracking => {
  return {
    analytics: {
      data: {
        capability: ImportOrderValidationAnalyticsMessages.capability,
        event: ImportOrderValidationAnalyticsMessages.submitFileEvent,
        file: {
          type: ImportOrderValidationAnalyticsMessages.fileType + typeOfFile,
        },
      },
      transformFunc: genericAnalyticsTransformer,
    },
  };
};
